<template>
  <div class="pages p20">
    <div class="title-btn-block">
      <div class="title-block">{{ $t("message.my_complaints") }}</div>
      <div>
        <router-link  :to="{ name: 'complaint'}">
            <div class="my-btn mr-2 el-button" style="background:#00CC00; color:#fff; margin-right: 10px;">
                Создать
            </div>
        </router-link>
        <router-link :to="{ name: 'Home' }">
          <div class="my-btn cr1 el-button">
            <i class="el-icon-d-arrow-left"></i> {{$t('message.back')}}
          </div>
        </router-link>
      </div>
    </div>
    <div class="content-block">
      <div class="datetime-end bg p20 mb20">
        <el-divider content-position="left"> {{ $t("message.my_complaints") }} </el-divider>
        <div class="etabl">
          <div class="scrol-table crmhome__scroll my-table">
            <table >
              <thead>
                <tr>
                  <th>{{ $t("message.whom_sent") }}</th>
                  <th>{{ $t("message.title") }}</th>
                  <th>{{ $t("message.message_text") }}</th>
                  <th>{{ $t("message.sent_time") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="complaint in complaints" :key="complaint.id">
                  <td>{{ complaint.manager ? complaint.manager.name +" "+ complaint.manager.last_name : '' }}</td>
                  <td>{{ complaint.header }}</td>
                  <td>{{ complaint.title }}</td>
                  <td>{{ complaint.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getItem } from "@/utils/storage";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      complaints: [],
    };
  },
  mounted() {
    this.getTable();
  },
  methods: {
    ...mapActions({
      updateList: "complaint/index",
    }),

    getTable() {
      this.updateList(getItem("userId"))
        .then((res) => {
          this.complaints = res;
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
  },
};
</script>
